import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseAppService from '../../../../application/platform/scp/base/base-app-service';
import { ACTION_TYPES, useContractSearchDispatch, useContractSearchState } from './contract-search-context';
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const useContractSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useContractSearchDispatch();
    const state = useContractSearchState();
    const { showLoading, showMessage } = useBaseLayout();

    useEffect(() => {
        loadInitialData();
    }, []);

    async function loadInitialData() {
        try {
            showLoading({ open: true });

            const typeContract = await BaseAppService.listTypeContract();
            const categoryProcess = await BaseAppService.listCategoryProcess();

            dispatch({ type: ACTION_TYPES.setTypeContract, payload: typeContract });
            dispatch({ type: ACTION_TYPES.setCategoryProcess, payload: categoryProcess });

            showLoading({ open: false });
        } catch (error) {
            showMessage({
                open: true,
                message: 'Não foi possível carregar os filtros de pesquisa',
                detail: (error as any).details || (error as Error).message,
                type: 'error'
            });
            showLoading({ open: false });
        }
    }

    function handleOnChange(e: any) {
        let term = state.parameters.term;
        let categoryProcessId = state.parameters.categoryProcessId;
        let contractTypeId = state.parameters.contractTypeId;
        let clientId = state.parameters.clientId;

        if (e.target.name === "input-term") {
            term = e.target.value;
        }
        if (e.target.name === "select-category-process") {
            categoryProcessId = e.target.value;
        }
        if (e.target.name === "select-contract-type") {
            contractTypeId = e.target.value;
        }
        if (e.target.name === "select-client") {
            clientId = e.target.value;
        }

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                term,
                clientId,
                categoryProcessId,
                contractTypeId
            }
        });
    }

    function handleSearch() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                page: 0
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                page: 0,
                pageSize: 100,
                term: undefined,
                clientId: undefined,
                categoryProcessId: undefined,
                contractTypeId: undefined
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() {
        navigate('/contratos/publicar');
    }

    return {
        handleOnChange,
        handleSearch,
        handleClearFilters,
        navigateToCreate
    };
}
